var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07583 1.83325L4.7575 5.16075",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9242 1.83325L17.2425 5.16075",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83333 7.19588C1.83333 5.50005 2.74083 5.36255 3.86833 5.36255H18.1317C19.2592 5.36255 20.1667 5.50005 20.1667 7.19588C20.1667 9.16671 19.2592 9.02922 18.1317 9.02922H3.86833C2.74083 9.02922 1.83333 9.16671 1.83333 7.19588Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94667 12.8333V16.0874",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1633 12.8333V16.0874",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20833 9.16675L4.50083 17.0867C4.79417 18.8651 5.5 20.1667 8.12167 20.1667H13.6492C16.5 20.1667 16.9217 18.9201 17.2517 17.1967L18.7917 9.16675",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsIcon);
export default __webpack_public_path__ + "static/media/products-icon.582855b9bdfb0aa8144256d24092ad7b.svg";
export { ForwardRef as ReactComponent };